<template>
  <div class="app-container">
    <div class="content">
      <div>
        <div class="news-detail">
          <div class="content" v-html="content"></div>
        </div>
      </div>
      <typing-first id="first" ref="first" @getResultA='getPercent' />
      <typing-first-b id="firstB" ref="first-b" v-if="isShow" @getFirstB="getFirstB" />
      <typing-second id="second" ref="second" v-if="isShow" @getAnswerSencond="getAnswerSencond"/>
      <typing-third id="third" ref="third" @getAnswerThird="getAnswerThird" :num="isShow ? 4 : 2" />
      <typing-fourth id="fourth" ref="fourth" v-if="answerThird > 0" @getAnswerFourth="getAnswerFourth" :num="isShow ? 5 : 3" />
      
    </div>
    <div style="margin-top:20px;text-align:center;background:#fff">
      <van-button  @click="submit()" class="button" color="#8259E1">提交</van-button>
    </div>
    <van-dialog v-model="show" title="提示" show-cancel-button confirm-button-text='是' cancel-button-text='否' @confirm="confirm">
      <div style="margin:20px">确定不使用食物回避（包括母亲饮食回避）进行诊断？</div>
    </van-dialog>
  </div>
</template>
<script>
import API from "@/api/common";
import typingFirst from "./components/question/typingFirst";
import typingFirstB from "./components/question/typingFirstB";
import typingSecond from "./components/question/typingSecond";
import typingThird from "./components/question/typingThird";
import typingFourth from "./components/question/typingFourth";
export default {
  components: {
    typingFirst,
    typingFirstB,
    typingSecond,
    typingThird,
    typingFourth
  },
  data() {
    return {
      content: '<p>尊敬的老师：</p><p>您好！为了更好的了解<strong>食物过敏临床诊疗情况</strong>，提供更专业的服务，惠及更多食物过敏患儿，希望能够占用您约5分钟时间，协助完成以下问卷。该问卷<strong>所有问答仅用于统计分析，答案没有对错，请根据您的临床实际情况放心填写！</strong></p><p>非常感谢您的支持！</p>',
      coverUrl: '',
      openid: this.$route.query.openid,
      defaultCoverUrl: require('../../assets/images/logo_ch.png'),
      form: {
        total: 0,
      },
      name: 'first',
      show: false,
      isShow: false,
      isFourthShow: false,
      isSecondShow: false,
      source: this.$route.query.source || 'typing',
      answerFirstB: '',
      answerSencond: '',
      answerThird: '',
      answerFourth: ''
    };
  },
  created() {
    this.$nextTick(()=>{
      this.isShow = this.$refs.first.answerObj.answers[3].checked;
    })
  },
  methods: {
    getPercent(e) {
      this.isShow = e.includes(4) ? true : false;
    },
    getFirstB(e) {
      this.isSecondShow = true
    },
    getAnswerSencond(e) {
      this.answerSencond = e
    },
    getThirdPercent(e) {
      this.isFourthShow = e
    },
    getAnswerThird(e) {
      this.answerThird = e
    },
    getAnswerFourth(e) {
      this.answerFourth = e
    },
    toTyping(value) {
      document.querySelector(value).scrollIntoView({
        behavior: "smooth"
      });
      if (value == '#first') {
        this.$refs.first.confirm = 'confirm'
      } else if (value == '#firstB') {
        this.$refs['first-b'].confirm = 'confirm'
      } else if (value == '#second') {
        this.$refs.second.confirm = 'confirm'
      } else if (value == '#third') {
        this.$refs.third.confirm = 'confirm'
      } else if (value == '#fourth') {
        this.$refs.fourth.confirm = 'confirm'
      }
    },
    confirm() {
      let first = this.$refs.first;
      let params = {
        openid: this.openid,
        examId: 'typingExam',
        meetingId: this.source,
          typingList: [
            first.answerObj, this.$refs.third.answerObj,]
      }
      this.saveResult(params)
    },
    saveResult(params) {
      // if (this.checkConfirm()) {
        API.saveResult(params).then(data => {
          if (data.success) {
            this.$router.push({
              name: 'submitTypingSuccess',
              query: { openid: this.openid,  examId: 'typingExam', source: this.source}
            });
          } else {
            this.$message.error(data.message)
          }
        })
      // } else {
      //   this.$message.error(`分型题目再次确认全部选择是才可以提交！`)
      // }
    },
    getFirstBValue() {
      let firstB = this.$refs['first-b'].answerObj;
      console.log(firstB.remark)
      if (firstB.remark == '建议回避2-6周时进行随诊') {
          firstB.value = '1'
      } else if (firstB.remark == '建议至少回避6周以后（如2个月、3个月）再进行随诊') {
          firstB.value = '2'
      } else if (firstB.remark == '没有明确时间，患儿如果有需要可以来复诊') {
          firstB.value = '3'
      }
    },
    getFourthValue() {
      let fourth = this.$refs.fourth.answerObj;
      console.log(fourth.remark)
      if (fourth.remark == 'A、1~2个月') {
          fourth.value = '1'
      } else if (fourth.remark == 'B、3~4个月') {
          fourth.value = '2'
      } else if (fourth.remark == 'C、5~6个月') {
          fourth.value = '3'
      } else if (fourth.remark == 'D、6个月及以上') {
          fourth.value = '4'
      }  
    },
    checkConfirm() {
      let form = this.$refs.confirm.form
      if (form.confirm1 == 1 && form.confirm4 == 1 && 
        ((this.isShow && form.confirm2 == 1) || !this.isShow) && 
        ((this.isSecondShow && form.confirm3 == 1) || !this.isSecondShow) && 
        ((this.isFourthShow && form.confirm5 == 1) || !this.isFourthShow)
      ) {
        return true
      }
      return false
    },
    submit() {
      let firstFlag = false;
      this.$refs.first.answerObj.answers.map(item => {
        if (item.checked) {
          firstFlag = true;
        }
      })
      if (firstFlag) {
        // if (this.$refs.third.answerObj.value && this.$refs.third.answerObj.value > 0) {
          if (this.isShow) {
            // this.getFirstBValue()
            if (this.$refs['first-b'].answerObj.value !== '') {
              // if (this.isSecondShow) {
                if (this.$refs.second.answerObj.value !== '') {
                  if (this.$refs.third.answerObj.value !== '') {
                    if (this.$refs.third.answerObj.value > 0) {
                      this.getFourthValue()
                      if (this.$refs['fourth'].answerObj.remark) {
                        let params = {
                          openid: this.openid,
                          examId: 'typingExam',
                          meetingId: this.source,
                            typingList: [
                              this.$refs.first.answerObj,
                              this.$refs['first-b'].answerObj,
                              this.$refs.second.answerObj,
                              this.$refs.third.answerObj,
                              this.$refs.fourth.answerObj]
                        }
                        this.saveResult(params)
                      } else {
                        this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                      }
                    } else {
                      let params = {
                        openid: this.openid,
                        examId: 'typingExam',
                        meetingId: this.source,
                          typingList: [
                            this.$refs.first.answerObj,
                            this.$refs['first-b'].answerObj,
                            this.$refs.second.answerObj,
                            this.$refs.third.answerObj]
                      }
                      this.saveResult(params)
                    }
                  } else {
                    this.$message.error(`第${this.isShow?'四':'二'}题必选！`)
                  }
                } else {
                  this.$message.error('第三题必选！')
                }
            } else {
              this.$message.error('第二题必选！')
            }
          } else {
            // this.show = true;
            if (this.$refs.third.answerObj.value !== '') {
              if (this.$refs.third.answerObj.value > 0) {
                this.getFourthValue()
                //判断第五题有没有填
                if (this.$refs['fourth'].answerObj.remark) {
                  let params = {
                    openid: this.openid,
                    examId: 'typingExam',
                    meetingId: this.source,
                    typingList: [
                      this.$refs.first.answerObj,
                      this.$refs.third.answerObj,
                      this.$refs.fourth.answerObj]
                  }
                  this.saveResult(params)
                } else {
                  this.$message.error(`第${this.isShow?'五':'三'}题必选！`)
                }
              } else {
                let params = {
                  openid: this.openid,
                  examId: 'typingExam',
                  meetingId: this.source,
                  typingList: [
                    this.$refs.first.answerObj,
                    this.$refs.third.answerObj]
                }
                this.saveResult(params)
              }
            } else {
              this.$message.error('第二题必选！')
            }
          }
      } else {
        this.$message.error('第一题必选！')
      }
    }
  },
};
</script>
<style lang="less">
  strong {
    color: purple;
  }
  p {
    margin: 0;
  }
</style>
<style lang='less' scoped>
.app-container{
  .banner {
    width: 100%;
    height: auto;
  }
  /deep/textarea{
    border:1px solid #ccc;
  }
  .button {
    width: 90%;
    margin: 25px auto;
    border-radius: 6px;
  }
  /deep/.van-cell-group{
    .question{
      font-size: 14px;
      padding: 5px 0;
    }
    .van-radio{
      margin:8px 0;
      font-size: 14px;
    }
    .van-checkbox__label{
      margin:8px;
      font-size: 14px;
    }
    margin:10px 20px;
    padding: 10px;
    border-radius: 5px;
    color: #646566;
  }
  .news-detail {
    height: 100%;
    margin-top: 20px;
    padding-bottom: 10px;
    overflow: auto;
    box-sizing: border-box;
    color: #646566;
    .title {
      font-size: 18px;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
      text-align: center;
    }
    .examType {
      font-size: 16px;
      text-align: center;
      font-weight: bold;
      border-bottom: 1px solid #f7f7f7;
    }
    .content {
      margin: 0 10px;
      font-size: 14px;
    }
  }
}

</style>
<style lang="less">
.content {
  .van-field__label {
    margin-left: 6px;
  }

  .van-icon__image {
    width: 18px;
    height: 18px;
  }
  .van-radio__label {
    color: #646566;
  }
}
</style>
